// extracted by mini-css-extract-plugin
export default {"ClientDetail":"StaffDetail_ClientDetail__o7MEN","tableResponsive":"StaffDetail_tableResponsive__6H5Zk"};